import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const listCoupons: DocumentNode = gql`
  query ListCoupons {
    listCoupons {
      data {
        id
        name
        code
        state
        duration
        temporalUnit
        temporalAmount
        appliesToAllPlans
        maxRedemptionsPerAccount

        discount {
          percent
          type
          currencies {
            amount
            currency
          }
          trial {
            length
            unit
          }
        }
      }
    }
  }
`

export default listCoupons
